module.exports = __webpack_public_path__ + "1d4bff23aec2805d01bf7d96c5d4d15f.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-overpass-mono/files/overpass-mono-latin-400.woff2
// module id = 170
// module chunks = 1